export default () => ({
  verticalLink: {
    textDecoration: 'none',
  },
});
